/* Input with Second Name auto-suggest (3+ letters), same source as the Order Register cell. */
import { useRef, useState } from "react";
import axios from "axios";
import { Input } from "./ui/input";
import { API, getAuthHeader } from "@/App";

export const SecondNameSuggestInput = ({ value, onChange, onEnter, className = "", placeholder, testId }) => {
  const [sug, setSug] = useState([]);
  const [idx, setIdx] = useState(-1);
  const t = useRef(null);
  const type = (raw) => {
    const v = raw.toUpperCase();
    onChange(v);
    setIdx(-1);
    if (t.current) clearTimeout(t.current);
    if (v.trim().length < 3) { setSug([]); return; }
    t.current = setTimeout(async () => {
      try {
        const r = await axios.get(`${API}/product-aliases/suggest`, { headers: getAuthHeader(), params: { q: v.trim(), limit: 30 } });
        const q = v.trim();
        setSug((r.data.rows || []).map(n => String(n || "").toUpperCase()).filter(n => n && n !== q)
          .sort((a, b) => { const r = (n) => (n.startsWith(q) ? 0 : n.split(/\s+/).some(w => w.startsWith(q)) ? 1 : 2); return r(a) - r(b) || a.localeCompare(b); }).slice(0, 6));
      } catch { setSug([]); }
    }, 250);
  };
  const pick = (s) => { onChange(s); setSug([]); };
  const key = (e) => {
    if (sug.length) {
      if (e.key === "ArrowDown") { e.preventDefault(); setIdx(i => (i + 1) % sug.length); return; }
      if (e.key === "ArrowUp") { e.preventDefault(); setIdx(i => (i <= 0 ? sug.length - 1 : i - 1)); return; }
      if (e.key === "Escape") { setSug([]); return; }
      if ((e.key === "Enter" || e.key === "Tab") && idx >= 0) { e.preventDefault(); pick(sug[idx]); return; }
    }
    if (e.key === "Enter") onEnter?.();
  };
  return (
    <div className="relative">
      <Input value={value} onChange={(e) => type(e.target.value)} onKeyDown={key} onBlur={() => setTimeout(() => setSug([]), 150)}
             placeholder={placeholder} className={`uppercase ${className}`} data-testid={testId}
             autoComplete="off" autoCorrect="off" spellCheck={false} enterKeyHint="done" />
      {sug.length > 0 && (
        <div className="absolute left-0 right-0 top-full mt-0.5 z-50 bg-white border border-slate-200 rounded shadow-lg max-h-44 overflow-auto"
             data-testid={`${testId}-suggest-list`}>
          {sug.map((s, i) => (
            <button key={s} type="button" onMouseEnter={() => setIdx(i)} onPointerDown={(e) => { e.preventDefault(); pick(s); }}
                    className={`w-full text-left px-2 py-1.5 max-md:py-2.5 max-md:text-xs text-[11px] font-semibold border-b border-slate-100 last:border-0 ${
                      i === idx ? "bg-indigo-100 text-indigo-800" : "text-slate-700 hover:bg-indigo-50"}`}
                    data-testid={`${testId}-suggest-item-${i}`}>{s}</button>))}
        </div>)}
    </div>
  );
};
